export const setLoading = (loading) => ({
  type: "SET_BOOKING_STATUSES_LOADING",
  data: loading,
});
export const addStatuses = (data) => ({
  type: "ADD_BOOKING_STATUSES",
  data: data.added,
});
export const updateStatuses = (data) => ({
  type: "UPDATE_BOOKING_STATUSES",
  data: data.modified,
});
export const deleteStatuses = (data) => ({
  type: "DELETE_BOOKING_STATUSES",
  data: data.removed,
});
